import { sessionEventTypes } from 'events/session';
import initialState from 'reducers/initialStates/session';

export default function sessionReducer(state = initialState, action) {
  switch (action.type) {
    case sessionEventTypes.SESSION_CREATE_ERROR:
      return handleSessionCreateError(state);

    case sessionEventTypes.SESSION_FETCH_SUCCESS:
    case sessionEventTypes.SESSION_CREATE_SUCCESS:
    case sessionEventTypes.SESSION_UPDATE_SUCCESS:
      return handleSessionSuccess(state, action);

    case sessionEventTypes.SESSION_SET_WELCOME_MESSAGE:
      return handleSetWelcomeMessage(state, action);

    case sessionEventTypes.SESSION_UPDATE_URL:
      return handleSessionUpdateUrl(state, action);

    default:
      return state;
  }
}

function handleSessionCreateError(state) {
  return { ...state, ready: false };
}

function handleSessionSuccess(state, action) {
  return { ...state, ...action.payload };
}

function handleSetWelcomeMessage(state, action) {
  return { ...state, welcomeMessage: action.payload };
}

function handleSessionUpdateUrl(state, action) {
  return { ...state, customerUrl: action.payload };
}
